<div class="wrap">
  <ng-container *ngFor="let m of menu">
    <ng-container *ngIf="isAuthorize(m.role)">
      <mat-card [ngSwitch]="m.iconType" (click)="goToUrl(m.url)" *ngIf="m.iconLabel !== 'faFileExcel'">
        <div class="header">
          <fa-icon *ngSwitchCase="'faicon'" [icon]="getFaIcon(m.icon)" appChangeColorTheme attribute="color"></fa-icon>
          <img [src]="m.icon" alt="club" *ngSwitchCase="'club'">
        </div>

        <mat-card-content appChangeColorTheme attribute="bgc">
          <h4><strong>{{m.name}}</strong></h4>
          <p>{{m.description}}</p>
        </mat-card-content>
      </mat-card>

      <mat-card [ngSwitch]="m.iconType" *ngIf="m.iconLabel === 'faFileExcel'" (click)="exportExcel()">
        <div class="header">
          <fa-icon *ngSwitchCase="'faicon'" [icon]="getFaIcon(m.icon)" appChangeColorTheme attribute="color"></fa-icon>
          <img [src]="m.icon" alt="club" *ngSwitchCase="'club'">
        </div>

        <mat-card-content appChangeColorTheme attribute="bgc">
          <h4><strong>{{m.name}}</strong></h4>
          <p>{{m.description}}</p>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>
</div>
